module.exports = __webpack_public_path__ + "img/84.9e6c5977.jpg";